import { ViewIds } from '@ardoq/api-types';
import {
  MetaInfo,
  MetaInfoViewStatus,
} from '../../streams/views/mainContent/types';

// Read about the logic and relevant code parts in
// https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2413002789/Discontinued+Views+engineering+perspective.

export const DEFAULT_REPLACEMENT_FOR_WORKSPACE_MODE = ViewIds.PAGESVIEW;

/**
 * @returns the successor of the discontinued view if defined, PAGESVIEW otherwise
 */
export const replaceViewIfDiscontinued = (
  viewId: ViewIds | null | undefined,
  deprecatedViews: MetaInfo[]
): ViewIds | null => {
  if (!viewId) {
    return null;
  }
  const deprecatedView = deprecatedViews.find(({ id }) => id === viewId);
  if (deprecatedView?.viewStatus !== MetaInfoViewStatus.DISCONTINUED) {
    return viewId;
  }
  return (
    deprecatedView.deprecationSuccessor ??
    DEFAULT_REPLACEMENT_FOR_WORKSPACE_MODE
  );
};

/**
 * Whether the view can be added to a presentation or be selected as a start
 * view for a workspace/template: it is one of the user's views in the mode, and
 * it is neither discontinued nor scheduled to be killed.
 *
 * Takes the view's meta info from the mode's views; a view the mode does not
 * offer has none.
 *
 * @see https://ardoqcom.atlassian.net/wiki/spaces/INSIGHT/pages/2413002789/Discontinued+Views+engineering+perspective
 */
export const isViewEligibleForNewAssets = (
  metaInfo: MetaInfo | undefined
): metaInfo is MetaInfo =>
  metaInfo !== undefined &&
  metaInfo.viewStatus !== MetaInfoViewStatus.DISCONTINUED &&
  !metaInfo.killDate;
